import Vue from 'vue'

class WebSocketService {
    constructor(url) {
        this.url = url
        this.ws = null
        this.heartbeatInterval = null
        this.reconnectTimeout = null
        this.eventBus = new Vue() // 创建事件总线
        this.reconnet = true
    }

    connect() {
        this.ws = new WebSocket(this.url)

        this.ws.onopen = () => {
            // this.startHeartbeat()
            this.reconnet = true
        }

        this.ws.onmessage = (message) => {
            this.eventBus.$emit('message-received', message.data) // 触发事件并传递数据
        }

        this.ws.onclose = () => {
            this.stopHeartbeat()
            this.reconnect()
        }

        this.ws.onerror = (error) => {
            console.error('WebSocket Error:', error)
            this.ws.close()
        }
    }

    pong() {
        this.ws.send(JSON.stringify({
            type: 'pong'
        }))
    }

    // startHeartbeat() {
    //     this.heartbeatInterval = setInterval(() => {
    //         if (this.ws.readyState === WebSocket.OPEN) {
    //             this.ws.send(JSON.stringify({
    //                 type: 'ping'
    //             }))
    //         }
    //     }, 9000) // 9秒心跳
    // }

    stopHeartbeat() {
        clearInterval(this.heartbeatInterval)
        this.heartbeatInterval = null
    }

    reconnect() {
        if (this.reconnet && !this.reconnectTimeout) {
            this.reconnectTimeout = setTimeout(() => {
                this.connect()
                this.reconnectTimeout = null
            }, 3000) // 重连
        }
    }

    close() {
        console.debug('WebSocket Close By Client')
        this.reconnet = false
        // this.stopHeartbeat()
        clearTimeout(this.reconnectTimeout)
        if (this.ws) {
            this.ws.close()
        }
    }
}

const WebSocketInstance = new WebSocketService('wss://amb.tx369.net:1234')
export default WebSocketInstance
